module.exports = {
  system: {
    changeLocale: 'Switch Language',
    create: 'Create',
    import: 'Import',
    delete: 'Delete',
    edit: 'Edit',
    detail: 'Detail',
    index: 'Index',
    operation: 'Operation',
    search: 'Search',
    reset: 'Reset',
    confirm: 'Confirm',
    save: 'Save',
    cancel: 'Cancel',
    export: 'Export',
    back: 'Back',
    pleaseInput: 'Please Input {0}',
    pleaseSelect: 'Please Select {0}',
    success: 'success',
    fail: 'fail',
    continue: 'Continue',
    enable: 'Enable',
    disable: 'Disable',
    emptySelection: 'Please select a record',
    option: 'Option',
    closeOthers: 'Close Others',
    closeAll: 'Close All',
    or: 'OR',
    hour: 'h',
    minuate: 'm',
    second: 's',
    yes: 'Yes',
    no: 'No',
    hello: 'hi {0}',
    enter: 'Enter the system',
    clip2copy: "Clip to copy",
    copySuccess: "Copy succeed",
    copyError: "Copy failed"

  },
  myValidate: {
    login: [
      'Please input correct mobile'
    ],
    register: [
      'Please input correct mobile'
    ],
    my: [
      'Please input correct mobile',
      'Please input correct email',
      'Please input correct identification',
      "Not same password"
    ]
  },
  menu: {
    home: 'Home',
    product: 'Product',
    service: 'Service',
    about: 'About',
    order: 'Order',
    bill: 'Bill',
    my: 'My',
    customs: "Customs",
    dashboard: "Home",
    booking: "Booking",
    mawb: "Mawb",
    trust: "客户托单",
    label: "Compliance",
    mawbOpt: "操作主单",
    databoard: "Databoard",
    coa: "Customs",
    hts: "HTS&Description",
    tariff: "Tariff",
    mid: "Mid Modify"
  },
  product: {
    ship: {
      title: 'Ocean',
      products: ['中美海运专线', '中美海运拼箱', '海外仓']
    },
    plane: {
      title: 'Air',
      products: ['中美空运专线', '中欧空运专线']
    },
    truck: {
      title: 'Land',
      products: ['中欧卡运专线']
    },
    railway: {
      title: 'Railway',
      products: []
    },
    description: '服务简介',
    info: '产品概况',
    title: '产品概况',
    goodsType: '货物类型',
    effectTime: '参考时效',
    unitWeight: '单价包裹限重',
    unitVolume: '单件包裹尺寸',
    mode: '计费模式',
    country: '服务国家',
    weightLimit: '重量限制',
    require: '申报要求',
    clearance: '报关服务',
    retunParts: '退件服务',
    intercept: '拦件服务',
    advantage: '产品优势',
    props: '走货属性',
    compensate: '赔偿标准',
    cutOff: '赔偿受理截止时间',
    standard: '索赔标准',
    exemption: '免责情况',
    returnBack: '退仓服务'
  },
  validate: {
    pwdLength: 'Should be 6-20 characters long',
    pwdReg: 'Letters or numbers only',
    pwdNotSame: 'Password not same'
  },
  login: {
    title: 'Login',
    mobile: 'Mobile',
    vcode: 'Verify code',
    getVCode: 'Get verify code',

    login: 'Login',
    logout: 'Logout',
    loginSuccess: 'Login successful',
    logoutSuccess: 'Logout successful',
    noAuth: 'Permission denied, pls contact manager',
    loginType: ['Mobile login', 'Account login'],
    account: 'Account',
    password: 'Password'
  },
  register: {
    title: 'Register',
    userName: 'User name',
    companyName: 'Company',
    mobile: 'Mobile',
    vcode: 'Verify Code',
    getVCode: 'Get verify code',
    register: 'Register',
    registerSuccess: 'Register successful'
  },
  search: {
    title: 'Shipment search',
    tips: 'Please input number',
    orderNumber: 'Order number',
    number: 'Number search',
    route: 'Product route',
    destination: 'Destination',
    transportType: 'Transport type',
    billWeight: 'Billing weight',
    volume: 'Volume',
    quantity: 'Quantity',
    status: 'Status',
    type: [
      "Order",
      "Reference",
      "Mawb",
      "Business"
    ],
    transportTypes: {
      2: "Air",
      3: "Ship"
    },
    mawbNumber: "Mawb No",
    fbaNumber: "Sub No",
    wtNo: "Commission No",
    org: "POA",
    dest: "POD",
    launchDate: "Flight date",
    launchNo: "Flight No",
    grossWeight: "Gross weight"
  },
  calc: {
    title: 'Fee trial',
    title2: "Fee consult",
    start: 'Sender region',
    startTip: 'Please input sender region eg:shanghai',
    end: 'Consignee region',
    endTip: 'Please input consignee region eg:USA',
    productName: 'Product name',
    productNameTip: 'Plaease input product name eg:美国海派FBA',
    packageType: 'Package type',
    normalPackage: 'Normal',
    electrifiedPackage: 'Electrified',
    packageWeight: 'Package weight',
    packageVolume: 'Package volume',
    searchResult: 'Search result：',
    resultTips: '（Tips：The product billing shall be subject to the actual order, and the information displayed in the list is for reference only）',
    table: [
      'Product name',
      'Consignee region',
      'Transport type',
      'Package type',
      'Prescription',
      'Volume',
      'Ratio',
      'Volume weight',
      'Gross weight',
      'Billing weight',
      'Freight',
      'Extra fee',
      'Total freight'
    ],
    createOrder: 'Place order'
  },
  status: [
    '已签收',
    '',
    '',
    '',
    '已交派',
    '',
    '',
    '',
    '',
    '',
    '',
    '已到达',
    '已起航',
    '',
    '',
    '已入集货仓',
    '',
    '',
    '已下单'
  ],
  bill: {
    title: 'Bill detail',
    account: 'Account',
    bond: 'Bond',
    quota: 'Quota',
    available: 'Available',
    history: 'History',
    unpaid: 'Unpaid',
    requireInvoice: 'Require invoice',
    detail: 'Detail',
    downloadPdf: 'Pdf',
    downloadExcel: 'Excel',
    excelFileName: 'Bill Detail',
    pdfFileName: 'Bill fee detail export',
    header: [
      'Bill No',
      'Customer',
      'Order No',
      'Bill date',
      'Pay date',
      'Bill amount',
      'Paid',
      'Unpaid',
      'Receive company',
      'Action',
      'Index'
    ],
    detailDialog: {
      title: 'Bill detail',
      index: 'Index',
      orderNumber: 'Order number',
      refNo: "Customer ref No",
      feeDate: 'Fee date',
      unitName: 'Unit name',
      billingWeight: 'Billing weight(KG)',
      quantity: 'Quantity',
      unitFee: 'Unit fee',
      feeType: 'Fee type',
      orderFee: 'Order fee(￥)',
      route: 'Route',
      transferNo: 'Transfer No',
      currency: "Currency",
      rate: "Rate",
      baseAmount: "Base amount"
    },
    pdf: [
      'Bill code',
      'Service company',
      'Account period',
      'Settlement bill',
      '<span>{0}</span> records， total money <span>{1}</span> yuan（Tax included）',
      'Please pay before {0}',
      'Payee',
      'Bank',
      'Account',
      'Remark'
    ],
    invoiceDialog: {
      requireInvoice: 'Require invoice',
      historyInvoice: 'History incoice',
      requestDate: 'Require date',
      invoiceStatus: 'Invoice status',
      invoiceType: 'Invoice type',
      table: [
        'Bill No',
        'Invoice type',
        'Bill date',
        'Bill amount',
        'Invoice header',
        'Invoice type',
        'Tax',
        'Actual invoice amount',
        'Require by',
        'Require date'
      ]
    }
  },
  my: {
    title: 'My',
    account: 'Account',
    business: 'Business',
    baseInfo: {
      title: 'Base info',
      type: 'Type',
      name: 'Name',
      code: 'Code',
      legalName: 'Legal name',
      legalId: 'Legal ID',
      status: 'Status',
      admin: 'Admin name',
      adminMobile: 'Admin mobile',
      adminEmail: 'Admin email',
      active: 'Actived',
      inactive: 'Inactive',
      updateSuccess: 'Update base info successful'
    },
    contacts: {
      title: 'Contacts info',
      name: 'Name',
      mobile: 'Mobile',
      role: 'Role',
      mail: 'E-mail',
      dataAuth: 'Authority',
      enable: 'Is enable',
      orgAuth: 'Organization data',
      userAuth: 'Personal data',
      create: 'Create contact',
      createSuccess: 'Contact create successful',
      update: 'Update contact',
      updateSuccess: 'Contact update successful',
      password: "Password",
      passwordConfirm: "Confirm password",
      resetPassword: "Reset password"
    },
    payments: {
      title: 'Pay info',
      number: 'Card/Account No',
      account: 'Account',
      name: 'Bank/Platform name',
      method: 'Pay mode',
      type: 'Pay type',
      remark: 'Remark',
      bank: 'Bank card',
      alipay: 'Alipay',
      wechat: 'Wechat pay',
      orgPay: 'Company',
      personalPay: 'Personal',
      create: 'Create pay account',
      createSuccess: 'Pay account create successful',
      update: 'Update pay account',
      updateSuccess: 'Pay account update successful'
    },
    receivable: {
      title: 'Receive info',
      name: 'Name',
      bank: 'Bank',
      account: 'Account',
      alipayName: 'Alipay name',
      alipayAccount: 'Alipay account',
      wechatName: 'Wechat pay name',
      wechatReceiveImage: 'Wechat pay image'
    },
    bank: 'Bank account info',
    alipay: 'Alipay account info',
    wepay: 'Wechat pay info',
    addressInfo: {
      title: '地址信息',
      country: '国家',
      address: '地址',
      phone: '电话',
      contact: '联系人',
      type: '类型',
      remark: '备注',
      orgAuth: '本机构数据',
      userAuth: '个人创建数据',
      create: '新增商品信息',
      createSuccess: '新增商品信息成功',
      update: '编辑商品信息',
      updateSuccess: '编辑商品信息成功'
    },
    taxInfo: {
      title: '税务信息',
      ZN: '中国税务信息',
      EU: '欧洲税务信息',
      US: '美国税务信息',
      type: '客户类型',
      address: '单位地址',
      phone: '电话',
      duty: '税号',
      bank: '开户行',
      bankAccount: '银行账户',
      vatNo: 'VAT号',
      eori: 'EORI号',
      ioss: 'IOSS号',
      ein: 'EIN号',
      //
      name: '客户名称',
      code: '客户编号',
      legalName: '法人姓名',
      legalId: '法人身份证',
      status: '账户状态',
      admin: '管理员用户名',
      adminMobile: '管理员手机号',
      adminEmail: '管理员电子邮箱',
      active: '已生效',
      inactive: '已失效',
      updateSuccess: '基本信息修改成功'
    },
    goodsInfo: {
      title: '商品信息',
      nameCn: '中文名',
      nameEn: '英文名',
      hscode: 'HSCODE',
      brand: '品牌',
      model: '型号',
      material: '材质',
      currency: '币种',
      purpose: '用途',
      diffPrice: '差价',
      create: '新增商品信息',
      createSuccess: '新增商品信息成功',
      update: '编辑商品信息',
      updateSuccess: '编辑商品信息成功',
      orgAuth: '本机构数据',
      userAuth: '个人创建数据',
    },
    cartonsInfo: {
      title: '纸箱信息',
      cartonRule: '箱规',
      long: '长CM',
      wide: '宽CM',
      high: '高CM',
      orgAuth: '本机构数据',
      userAuth: '个人创建数据',
      create: '新增纸箱信息',
      createSuccess: '新增纸箱信息成功',
      update: '编辑纸箱信息',
      updateSuccess: '编辑纸箱信息成功'
    }
  },
  about: {
    SeeMore: 'See more',
    contactUs: 'Contact us'
  },
  order: {
    placeOrder: 'Create',
    query: 'Filter',
    form: {
      orderNo: {
        placeholder: 'Order No/Customer No/Transfer No'
      },
      createTime: {
        placeholder: ['Start', 'End']
      }
    },
    search: 'Search',
    historicalOrders: 'History',
    workingOrders: 'In progress',
    edit: 'Edit',
    print: 'Print',
    printDialogTitle: "Preview",
    cancel: 'Cancel',
    submit: 'Confirm',
    orderNumber: 'Order number',
    status: "Status",
    statusDate: "Status date",
    orderTime: 'Create date',
    eta: 'ETA',
    referenceNumber: 'Ref No',
    trackingNo: 'Transfer No',
    isCustoms: "Is customs",
    actualPksNum: 'Amount',
    actualVolume: 'Volume',
    chargingWeight: 'Billing weight',
    channelName: 'Channel',
    destinationCountry: 'To',
    fbaNo: "FBA No",
    operation: 'Action',
    placeOrderDialog: {
      title: 'Order import',
      steps: ['Upload excel', 'Data preview', 'Data import'],
      uploadBtn: 'Upload',
      downloadBtn: 'Download template',
      errorMsg: 'Error message:',
      next: 'Next',
      prev: 'Prev',
      done: 'Done',
      onlyXlsx: "Only xlsx supported"
    }

  },
  orderDetail: {
    image: "Product pic",
    orderNumber: 'Order No',
    createDate: 'Create date',
    eta: 'ETA',
    refNo: 'Ref No',
    transferNo: 'Transfer No',
    route: 'Route',
    status: 'Status',
    fbaNo: "FBA",
    destination: 'Destination',
    transportType: 'Transport type',
    detail: 'Cargo detail',
    quantity: 'Quantity',
    grossWeight: 'Gross weight',
    volume: 'Volume',
    billingWeight: 'Billing weight',
    isSelfClearance: 'Is self clearance',
    uploadClearanceFile: 'Upload clearance file',
    uploaded: "Uploaded",
    downloadReleaseFile: 'Download release file',
    sender: 'Sender',
    senderCompany: 'Sender company',
    senderAddress: 'Sender address',

    consignee: 'Consignee',
    consigneeCompany: 'Consignee company',
    consigneeAddress: 'Consignee address',
    notifier: 'Notifier',
    notifierCompany: 'Notifier company',
    notifierAddress: 'Notifier address',

    company: 'Company',
    address: 'Address',

    postCode: 'Post code',
    tel: 'Tel',
    fax: 'Fax',
    email: 'Email',
    goodsInfo: 'Cargo info',
    goodsTable: [
      'OMS Name CH',
      'Name EN',
      'OMS hsCodeCn',
      'hsCode',
      'brand',
      'Model',
      'material',
      'Usage',
      'special Goods Properties',
      'pieces',
      // 'Quantity per box',
      // 'Total declare quantity',
      'Unit fee（USD）',
      'Total fee（USD）',
      "Operate"
      // 'Gross weight',
      // 'Net weight',
      // 'Box length',
      // 'Box width',
      // 'Texture',
      // 'Usage',
      // 'Model'
    ],
    filesTable: [
      "File name",
      "Upload date",
      "Uploader",
      "Operate",
      "File type"
    ],
    cancelConfirm: 'Cancel edit?',
    uploadImage: "Upload pic",
    previewImage: "Preview pic"
  },

  dashboard: {
    left: {
      order: "Orders",
      detail: "Detail",
      createOrder: " Created",
      notUpdateYet: "Not updated",
    },
    right: {
      error: "Abnormal",
      detail: "Detail",
      infoError: "Info abnormal",
      statusError: "Status abnormal",
      customerService: "Customer service",
      saleService: "Salesman service"
    },
    statusList: [
      "已下单",
      "已入集货仓",
      "已出集货仓",
      "出口已放行",
      "已起航",
      "已到港",
      "清关中",
      "已交派",
      "已签收",
    ],
    transportType: {
      1: "Air",
      2: "Ship",
      3: "Truck",
      4: "Rails",
      "null": "Unknown"
    }
  },
  sheet: {
    currentStatus: "Current status",
    orderNumber: "Order No",
    handler: "Handler",
    createDate: "Create date",
    communicateRecord: "Communication record",
    description: "Desription",
    comment: "Comment...",
    commentZone: "Comment zone",
    reply: "Reply",
    submit: "Submit",
    cancel: "Cancel",
    send: "Send",
    saySomething: "Say something..."
  },
  404: {
    tip: 'Page not exist',
    backToHome: 'Back to home',
    backToPre: 'Back to previous page'
  },
  403: {
    tip: 'No permission to access this page',
    backToHome: 'Back to home',
    backToPre: 'Back to previous page'
  },
  customs: {
    waybillNumber: "Waybill No",
    wplaceholder: "Input waybill no",
    referenceNo: "Customer No",
    customsNo: "Customs declaration No",
    customsNo2: "House Waybill",
    orderDate: "Create date",
    customsDate: "Customs date",
    status: "State",
    quantity: "Number",
    volume: "Volume",
    packages: "Packages",
    grossWeight: "Gross weight",
    currency: "Currency",
    totalAmount: "Value",
    tariff: "Tariff(￥)",
    vat: "Tax(￥)",
    totalTax: "Total(￥)",
    download: "Download",
    filesTable: [
      "File type",
      "File name",
      "Preview",
      "Download"
    ],
    deliveryTable: [
      "Route",
      "Quantity",
      "Time"
    ],
    statusList: [
      "Submission of documents",
      "Customs clearance in progress",
      "Tax to be paid",
      "Tax paid",
      "Released",
      "Sent",
      "signed"
    ],
    statusList2: [
      "Flight Departure",
      "Flight Arrival",
      "Submission",
      "Clearancing",
      "Tax to pay",
      "Tax paid",
      "Released",
      "Inbound",
      "Outbound",
      "Delivery",
      "Signed"
    ],
    businessType: {
      0: "",
      1: "欧洲空派专线",
      2: "保税区仓库出货",
      3: "海运出口全程",
      4: "空运进口报关",
      5: "空运出口全程",
      6: "一线进境报关",
      7: "空运包机散货",
      8: "海运普货进口",
      9: "海运普货出口",
      14: "APPLE",
      15: "陆运",
      16: "包机",
      17: "7501清关",

    },
    abnormalTitle: "Detail",
    abnormalList: [
      "Custome Inspection",
      "CIQ inspection",
      "Document",
      "Exit customs",
      "Fumigation",
      "Invoice document",
      "Packing list receipt",
      "ClQ sampling picking"
    ],
    bizTypes: {
      1: "Customs declaration documents",
      2: "Other documents",
      8: "Release note",
      10: "Waybill",
      11: "Tax payment form"
    }
  },
  booking: {
    submit: "Submit",
    add: "Add",
    createSuccess: "Booking successfully",
    typeDeclaration: "Declaration",
    typeClearance: "Clearance",
    title: "Booking",
    limit: "Overweight,booking refused",
    dateType: "Flight date",
    goodsDetail: "CARGO DETAIL*",
    mawbNo: "MAWB NO",
    product: "Product",
    length: "Length",
    width: "Width",
    height: "Height",
    qty: "Quantity",
    quantity: "Quantity",
    grossWeight: "Gross weight",
    volume: "Volume",
    billingWeight: "Billing weight",
    wmsQuantity: "Preparation quantity",
    wmsGrossWeight: "Preparation weight",
    wmsVolume: "Preparation volume",
    wmsBillingWeight: "Preparation chargable weight",
    fba: "MARKS NOS",
    goodsName: "Cargo name",

    cargoSize: "Cargo size",
    hawbInfo: "HAWB Info",
    hawbTable: {
      hawbNo: "Hawb No",
      shipBill: "Ship bill",
      sealNo: "Seal no",
      bookingPkgsNum: "Quantity",
      bookingGrossWeight: "Gross weight",
      bookingVolume: "Volume",
      customsType: "Customs type"
    },
    cm: "CM",
    inch: "Inch",
    sft: "SHIPPER/CONSIGNEE/NOTIFY*",
    senderInfo: "Shipper",
    senderName: "Shipper",
    senderTel: "Shipper tel",
    senderAddress: "Shipper address",
    consigneeInfo: "Consignee",
    consigneeName: "Consignee",
    consigneeTel: "Consignee tel",
    consigneeAddress: "Consignee address",
    notifyInfo: "Notify",
    alsoNotify: "Also notify",
    bookingReq: "DELIVERY INFO*",
    bookingReq2: "Requirements",
    zdfd: "Direct/Separate",
    paymentType: "Airfreight/Other charge",
    billType: "Bill type",
    salesCompany: "Sales company",
    reserveFlightnr: "Flightnr",
    flightnrDate: "Flight date",
    positionReq: "Position requirement",
    specialApply: "Special price",
    remark: "Remark",
    valueAddedServices: "FILE UPLOAD*",
    customsDeclaration: "Export declaration",
    declarationFiles: "Declaration files",
    customsClearance: "Import declaration",
    clearanceFiles: "Clearance files",
    pickUpService: "Pickup service",
    warehouseCode: "Receiving warehouse",
    pickUpAddress: "Pickup address",

    transfer: "Transshipment",
    transferAddress: "Port of destination",
    transferPhone: "Tel",
    deadline: "Deadline",
    book: "Booking",
    bookInfoError: "No flight info",
    waybillTypeOptions: ["Direct", "Separate"],
    paymentTypeOptions: ["P", "C"],
    billTypeOptions: ["L/C", "T/T", "D/A", "D/P", "O/A"],
    // positionRequireOptions: ["Must go", "Stand by","Normal"],
    positionRequireOptions: {
      0: "Must go",
      1: "Stand by",
      2: "Normal",
      "-1": "Normal",
      "null": "Normal"
    },
    radioOptions: ["No", "Yes"],
    pickupServiceOptions: ["Self warehouse", "Pick up", "Self airport"],
    upload: "Upload",
    address: {
      YNT: "Yantai",
      TNA: "Jinan",
      TSN: "Tianjin",
      NKG: "Nanjing",
      PEK: "Peking",
      PVG: "Shanghai",
      KNH: "Nanchang",
      WUH: "Wuhan",
      XIY: "Xi'an",
      DLC: "Dalian",
      CSX: "Changsha",
      HRB: "Harbin",
      CKG: "Chongqing",
      CTU: "Chengdu",
      CAN: "Guangzhou",
    },
    itemTable: [
      "CHINESE HSCODE",
      "CHINESE NAME OF GOODS",
      "NO.PKGS",
      "KGS"
    ]
  },
  mawb: {
    funcError: "Page error",
    oidError: "Mawb info error",
    updateSuccess: "Update successfully",
    flightDate: "Flight date",
    mawbOrFlightNo: "Mawb or flight no",
    export: "Export",
    table: [
      "Status",
      "Mawb no",
      "Flight no",
      "Flight date",
      "Launch date",
      "Arrive date",
      "Dest port",
      "Quantity",
      "Gross weight",
      "Volume",
      "Billing weight",
      "Remark"

    ],
    status: {
      0: "Rejected",
      29: "Booking",
      30: "Rejected",
      31: "Booked",
      32: "Stored",
      3: "Take off",
      4: "Arrived",
      33: "Assembled",
      34: "Notified",
      8: "Picked",
      42: "Coupon",
      41: "Received",
      40: "Dismantle",
      44: "Checked",
      43: "Confirmed",
      45: "Pounded"
    },
    print: "Print",
    exportPdf: "Export PDF"
  },
  databoard: {
    flightnr: "Flightnr",
    etd: "ETD",
    pol: "POL",
    pod: "POD",
    mawbNumber: "Mawb",
    grossWeight: "GW",
    volume: "Cubic",
    thisBillingWeight: "This Flightnr GW",
    lastBillingWeight: "Last Flightnr GW",
    takeOff: "Take off",
    takeOffed: "Already taked off",
    waitingForApproval: "Waiting for approval",
    waitingForWarehousing: "Waiting for warehousing",
    toBePrepared: "To be prepared",
    customerConfirmation: "Customer confirmation",
    transmissionOfCustomsDeclarationData: "Transmission of customs declaration data",
    toBeReleased: "To be released",
    status: "Status",
    completeRate: "Completion rate",
    thisFlightnrWarehousing: "This Flightnr Warehousing",
    nextFlighnrBooking: "Next Flighnr Booking",
    bookingGw: "Booking GW",
    bookingVol: "Booking Volumne",
    rebubbleRatio: "Rebubble ratio",
    lastFlightPlate: "Last Fligntnr",
    mawb: "MAWB",
    plate: "Plate",
    uldIn: "ULD In",
    startBreakdown: "Start Breakdown",
    tallyFinished: "Tally finished",
    outbound: "Outbound",
    customerGW: "Customer GW"




  },
  label: {
    orderNo: "Order No",
    createDate: "Create date",
    pick: "Pick",
    pickSuccess: "Pick success",
    pickTypeOpt: ["Unselected", "Style&Color", "Style"],
    verificationStatusOpt: ["No pic", "Taking pic", "Pic taked", "Compliant"],
    labelStatusOpt: [
      "Imported",
      "Mapping",
      "Mapped",
      "Taking photo",
      "Photographed",
      "In compliance",
      "Compliant",
      "Done",
    ],
    pickListBtn: "Picking list",
    styleCount: "Style Count",
    status: "Status",
    cargoInfo: "Cargo info",
    table: [
      "Style No",
      "Color",
      "Product",
      "Composition",
      "Unit price",
      "Status",
      "Image",
      "Feedback"
    ],
    pickListTable: [
      "CartonNo",
      "StyleNo",
      "Color",
      "Origin",
      "Qty",
      "PICKING LIST",
      "Remark",
      "Total Case Cnt",
      "Total Style Cnt"
    ],
    import: {
      title: "Order Import",
      scheme: "Scheme",
      brand: "Brand",
      invoiceFile: "Invoice file",
      masterFile: "Master file",
      otherFIle: "Other file",
      uploadBtn: "Upload",
      hint: "Error message"
    },
    detailDialog: {
      title: "Feedback",
      barcode: "Barcode",
      style: "Style",
      color: "Color",
      size: "Size",
      season: "Season",
      desc: "Product",
      composition: "Composition",
      question: "Question",
      response: "Response",
      image: "Image"
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/languages/en.js